import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";
import { BundleInterface } from '../../store/mods_factory/bundlesSlice';

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    thumbnail_url: modsfactoryUrls.remoteUrl(value.thumbnail_url),
  };
}

export const bundlesEntity = new schema.Entity(
  'bundles',
  {},
  {
    processStrategy
  }
);

export const bundleEntity = new schema.Entity(
  'bundle',
  {},
  {
    processStrategy
  }
);

const fetchBundlesCollection = async (url: string, params: object = {}) => {
  const response    = await modsFactoryApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      bundles: { [key: string]: BundleInterface };
    }
  >(response.data.bundles, [bundlesEntity]);

  return {
    bundles: normalized.entities?.bundles || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      bundle: BundleInterface;
    }
  >(response.data.bundle, bundleEntity);
  return normalized.entities;
}

export const fetchBundles = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundles`,
  async (params: object = {}) => fetchBundlesCollection('/onesky/bundles', params)
);

export const fetchBundle = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundle`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/bundles/${id}`);
    return normalizeInstance(response);
  }
);

export const updateBundle = createAsyncThunk(
  `${PREFIX}_bundles/updateBundle`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/bundles/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyBundle = createAsyncThunk(
  `${PREFIX}_bundles/destroyBundle`,
  async (id: number) => {
    const response = await modsFactoryApi.delete(`/onesky/bundles/${id}`);
    return response.data;
  }
);
